import SidebarRequestLogCardShimmer from "@/components/SidebarRequestLogCardShimmer";

const REQUEST_LOG_CARD_SHIMMER_KEYS = Array.from(
  { length: 20 },
  (_, index) => `request-log-card-shimmer-${index + 1}`,
);
const SHIMMER_STAGGER_DELAY_MS = 55;

const RequestLogsLoadingShimmer = () => (
  <>
    {REQUEST_LOG_CARD_SHIMMER_KEYS.map((key, index) => (
      <SidebarRequestLogCardShimmer key={key} animationDelayMs={index * SHIMMER_STAGGER_DELAY_MS} />
    ))}
  </>
);

export default RequestLogsLoadingShimmer;
